import { useToast } from "./useToast"

export const useClipboard = () => {
    const toast = useToast()

    const share = (successMsg: string) => {
        navigator.clipboard.writeText(window.location.href)
        toast.info(successMsg)
    }

    const copyToClipboard = (text: string, successMsg: string) => {
        navigator.clipboard.writeText(text)
        toast.info(successMsg)
    }

    return { share, copyToClipboard }
}
